export default function WhatIsSection() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-center mb-16 text-gray-900">
          家賃ゼロ太郎くんとは?
        </h2>
        
        <div className="space-y-8">
          <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl p-8 border border-teal-100">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-teal-500 text-white rounded-full flex items-center justify-center text-xl font-bold">
                ①
              </div>
              <div>
                <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                  国のシステムを利用し、あなたの生活費を補うシステムです。
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-8 border border-emerald-100">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-emerald-500 text-white rounded-full flex items-center justify-center text-xl font-bold">
                ②
              </div>
              <div>
                <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                  金融機関の協力を得ているのであなたの現金を使う必要がありません。
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-50 to-emerald-50 rounded-2xl p-8 border border-teal-100">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-teal-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                ③
              </div>
              <div>
                <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                  NISAのような投資プログラムを活用しています。こちらも、もちろん現金は不要です。
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-8 border border-emerald-100">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-emerald-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                ④
              </div>
              <div>
                <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                  毎年継続して利用可能です。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-2xl p-10 border-2 border-amber-200 shadow-lg">
            <p className="text-2xl md:text-3xl font-bold text-gray-900 leading-relaxed">
              結果、キャッシュが残るシステムとなっています。
            </p>
          </div>
        </div>

        <div className="mt-16 space-y-8">
          <div className="text-center">
            <p className="text-xl md:text-2xl text-gray-800 leading-relaxed mb-2">
              ただし、このシステムには、
            </p>
            <p className="text-xl md:text-2xl font-bold text-gray-900 leading-relaxed">
              利用できる方に一定の条件があります。
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 md:p-10 border-2 border-gray-200 shadow-lg">
            <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
              対象となるのは、以下に該当する方です。
            </h3>

            <div className="space-y-6">
              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gray-700 text-white rounded-full flex items-center justify-center text-lg font-bold">
                    ①
                  </div>
                  <div className="flex-1">
                    <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                      きちんとお仕事をされている方
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gray-700 text-white rounded-full flex items-center justify-center text-lg font-bold">
                    ②
                  </div>
                  <div className="flex-1">
                    <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                      勤続年数3年以上の方
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gray-700 text-white rounded-full flex items-center justify-center text-lg font-bold">
                    ③
                  </div>
                  <div className="flex-1">
                    <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                      年齢が55歳以下の方
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-10 h-10 bg-gray-700 text-white rounded-full flex items-center justify-center text-lg font-bold">
                    ④
                  </div>
                  <div className="flex-1">
                    <p className="text-lg md:text-xl text-gray-800 leading-relaxed">
                      これまでに昇進のご経験がある方
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 bg-gradient-to-r from-teal-50 to-emerald-50 rounded-xl p-6 border border-teal-200">
              <p className="text-base md:text-lg text-gray-800 leading-relaxed text-center">
                これらの条件を満たしていれば、<br className="hidden md:block" />
                <strong className="text-teal-700">
                  家賃ゼロ太郎くんを利用できる可能性は高いです。
                  <br className="hidden md:block" />
                  (<span style={{ color: 'rgb(31, 41, 55)', fontWeight: 400, backgroundColor: 'rgb(255, 251, 235)' }}>ただし、すべての方に確約できるものではありません。</span>)
                </strong>
              </p>
            </div>
          </div>

          <div className="mt-16 bg-gradient-to-br from-teal-50 via-emerald-50 to-teal-50 rounded-2xl p-10 md:p-12 border-2 border-teal-200 shadow-lg">
            <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8">
              【家賃ゼロ太郎くん】を提供している会社
            </h3>
            
            <div className="bg-white rounded-xl p-8 shadow-sm border border-teal-100">
              <h4 className="text-2xl md:text-3xl lg:text-4xl font-bold text-teal-600 text-center mb-8">
                株式会社オントラスト
              </h4>
              
              <div className="space-y-4 text-lg md:text-xl text-gray-800 leading-relaxed">
                <p>
                  私たちは、【家賃ゼロ太郎くん】を通じて、
                </p>
                <p className="font-semibold text-teal-700">
                  パーソナルファイナンスとパブリックファイナンスを提供する会社です。
                </p>
                <p className="mt-6">
                  国の制度や金融の仕組みを活用し、無理のない形で生活費の負担を軽くするサポートを行っています。
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 space-y-10">
          <div className="text-center space-y-6">
            <p className="text-2xl md:text-3xl font-bold text-gray-900 leading-relaxed">
              <div></div>
              <div>家賃ゼロ太郎くんの利用費用はいくらでしょうか?</div>
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 md:p-10 border-2 border-gray-200 shadow-lg">
            <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed">
              <div className="text-center space-y-4">
                <p>
                  あなたの家賃が10万円だったら・・・<br />
                  5年間で600万円です。<br />
                  10年間なら1200万円です。<br />
                  15年間なら1800万円です。
                </p>
                <p className="font-bold text-gray-900 mt-6">
                  あなたがこのノウハウにいくらの価値があると思いますか?
                </p>
                <p className="mt-4">
                  一生無料になるのなら、
                </p>
              </div>

              <div className="mt-8 space-y-4 text-center">
                <p className="font-semibold text-gray-900">
                  5年間分(600万円)くらい払えるでしょうか?
                </p>

                <p className="font-semibold text-gray-900">
                  それとも3年間分(360万円)くらいでしょうか?
                </p>

                <p className="font-semibold text-gray-900">
                  それとも1年間分(120万円)くらいでしょうか?
                </p>

                <p className="text-xl font-bold text-teal-700 mt-6">
                  そうなんです。1年間分頂いています。
                </p>

                <div className="mt-8 space-y-4">
                  <p className="font-semibold text-gray-900">
                    ですが、
                  </p>
                  <p>
                    今回私は多くの方に知っていただきたい、<br className="hidden md:block" />
                    利用していただきたいと本気で思っています。
                  </p>
                  <p className="text-3xl md:text-4xl font-bold text-gray-900 leading-relaxed">
                    だから私の本気の価格を<br className="hidden md:block" />知っていただきたいと思っています。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 md:p-10 border-2 border-gray-200 shadow-lg">
            <div className="text-center space-y-8">
              <div className="relative my-16">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-full h-1 bg-gradient-to-r from-transparent via-teal-300 to-transparent"></div>
                </div>
                <div className="relative flex justify-center">
                  <div className="bg-white px-8 py-4">
                    <p className="text-3xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600 animate-pulse drop-shadow-lg">
                      それは・・・
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-12">
                <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl p-8 border-4 border-gray-300 shadow-xl">
                  <p className="text-4xl md:text-6xl font-black text-gray-500">
                    120万円
                  </p>
                  <p className="text-xl md:text-2xl text-gray-400 font-medium mt-2">
                    ではなく・・・
                  </p>
                </div>

                <div className="flex justify-center py-6">
                  <i className="ri-arrow-down-line text-6xl text-gray-400"></i>
                </div>

                <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl p-8 border-4 border-gray-300 shadow-xl">
                  <p className="text-4xl md:text-6xl font-black text-gray-500">
                    60万円
                  </p>
                  <p className="text-xl md:text-2xl text-gray-400 font-medium mt-2">
                    でもなく・・・
                  </p>
                </div>

                <div className="flex justify-center py-6">
                  <i className="ri-arrow-down-line text-6xl text-teal-500"></i>
                </div>

                <div className="relative py-12">
                  {/* 背景の光彩エフェクト */}
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-96 h-96 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-full blur-3xl opacity-40 animate-pulse"></div>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-64 h-64 bg-gradient-to-br from-amber-300 to-yellow-300 rounded-full blur-2xl opacity-20 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
                  </div>

                  <div className="relative">
                    {/* 上部バッジ */}
                    <div className="flex justify-center mb-4">
                      <span className="inline-flex items-center gap-2 bg-red-500 text-white text-lg md:text-xl font-black px-6 py-2 rounded-full shadow-lg animate-bounce">
                        <i className="ri-fire-fill"></i>
                        特別価格
                        <i className="ri-fire-fill"></i>
                      </span>
                    </div>

                    {/* メイン価格ボックス */}
                    <div className="bg-gradient-to-br from-teal-400 via-emerald-500 to-teal-600 rounded-3xl p-1 shadow-2xl">
                      <div className="bg-gradient-to-br from-teal-500 via-emerald-500 to-teal-700 rounded-3xl px-10 py-12 border-4 border-white/40">
                        <div className="space-y-3">
                          <p className="text-2xl md:text-3xl font-bold text-white/80 tracking-widest">
                            たったの
                          </p>
                          <p className="text-6xl md:text-8xl font-black text-white leading-none drop-shadow-2xl" style={{ textShadow: '0 0 40px rgba(255,255,255,0.5)' }}>
                            15万円
                          </p>
                          <p className="text-3xl md:text-5xl font-black text-amber-300 drop-shadow-lg">
                            です！！
                          </p>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>

              <div className="mt-10 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-8 border-2 border-amber-200">
                <p className="text-xl md:text-3xl font-bold text-gray-900 leading-relaxed">
                  10万円の家賃のたったの1.5か月分で<br className="hidden md:block" />
                  生涯家賃が無料です。
                </p>
                <p className="text-base md:text-2xl text-gray-800 mt-4">
                  これならば喜んでいただけますでしょうか？
                </p>
              </div>
            </div>
          </div>

          <div className="relative my-32">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-full h-1 bg-gradient-to-r from-transparent via-red-300 to-transparent"></div>
            </div>
            <div className="relative flex justify-center">
              <div className="bg-white px-8 py-4">
                <p className="text-xl sm:text-3xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-orange-600 animate-pulse cursor-pointer">
                  いや、ちょっと待ってください!
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-teal-600 to-emerald-600 rounded-2xl p-10 md:p-12 border-2 border-teal-700 shadow-2xl">
            <div className="text-center space-y-8">
              <p className="text-2xl md:text-3xl font-bold text-white leading-relaxed">
                今回は一般開放が初めての為、面談をさせていただきたいです。お手間を取らせる為、
              </p>
              
              <div className="relative py-10">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-96 h-96 bg-gradient-to-br from-amber-300 to-yellow-400 rounded-full blur-3xl opacity-40 animate-pulse"></div>
                </div>
                <div className="relative">
                  <div className="inline-block bg-gradient-to-br from-amber-400 via-yellow-400 to-amber-500 px-12 py-10 rounded-3xl shadow-2xl transform hover:scale-105 transition-transform border-4 border-white">
                    <div className="text-center space-y-4">
                      <div className="flex items-center justify-center gap-3 mb-4">
                        <i className="ri-calendar-event-fill text-5xl text-red-600 animate-bounce"></i>
                        <p className="text-3xl md:text-4xl font-black text-red-600 drop-shadow-lg">
                          期間限定
                        </p>
                        <i className="ri-calendar-event-fill text-5xl text-red-600 animate-bounce"></i>
                      </div>
                      <p className="text-2xl md:text-3xl font-bold text-gray-900">
                        2026年4月30日までに
                      </p>
                      <p className="text-2xl md:text-3xl font-bold text-gray-900">
                        お申し込みの方に限り
                      </p>
                      <div className="py-4">
                        <p className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-600 drop-shadow-2xl tracking-wider">
                          着手料完全無料
                        </p>
                      </div>
                      <p className="text-2xl md:text-3xl font-bold text-gray-900">
                        で対応させていただきます!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <p className="text-base md:text-xl text-white leading-relaxed">
                  ただし、成果が確認できた場合は、15万円の成果報酬をいただきます。<br className="hidden md:block" />そのため、初回の面談は無料です。
                </p>
              </div>

              <div className="mt-8">
                <a
                  href="https://form.run/@yachinzero"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 md:gap-3 flex-wrap bg-white text-teal-600 px-8 md:px-12 py-5 md:py-6 rounded-lg text-base md:text-xl font-bold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-calendar-check-line text-xl md:text-2xl"></i>
                  今すぐ個人面談(無料)に申し込む
                </a>
              </div>
            </div>
          </div>

          <div className="mt-20">
            <h3 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
              【家賃ゼロ太郎くん】を導入された方からお喜びの声をいただいております。
            </h3>

            <div className="space-y-10">

              {/* Card A */}
              <div className="relative bg-amber-50 rounded-3xl border-2 border-amber-400 px-6 pb-8 pt-10">
                {/* 名前タグ */}
                <div className="absolute -top-5 left-6 bg-amber-200 border-2 border-amber-400 rounded-2xl px-5 py-2 shadow">
                  <p className="text-amber-900 font-black text-lg whitespace-nowrap">Aさん(45歳・会社員)</p>
                </div>

                {/* アバター + 吹き出し */}
                <div className="flex items-center gap-5 mt-2">
                  {/* アバター */}
                  <div className="flex-shrink-0 w-24 h-24 rounded-full border-4 border-amber-300 overflow-hidden">
                    <img
                      src="https://storage.readdy-site.link/project_files/4da40bb9-7576-4498-b48d-80e36ebd8220/6a009501-e51e-42bc-9497-c6a62e5f4cf5_27190257.png?v=32628e6088723b533271e66f324ddcfd"
                      alt="アバター"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>

                  {/* 吹き出し */}
                  <div className="relative flex-1 bg-white rounded-2xl border-2 border-amber-300 px-5 py-4">
                    <div
                      className="absolute top-8 -left-3"
                      style={{
                        width: 0,
                        height: 0,
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: '12px solid #fcd34d',
                      }}
                    ></div>
                    <div
                      className="absolute top-8 -left-2"
                      style={{
                        width: 0,
                        height: 0,
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: '12px solid #ffffff',
                      }}
                    ></div>
                    <p className="text-base md:text-lg text-gray-800 leading-relaxed text-center">
                      「月20万円の家賃がほぼゼロになり、<br className="hidden md:block" />
                      年間240万円の余裕が生まれました。<br className="hidden md:block" />
                      子供の教育費や家族旅行にお金を使えるようになり、<br className="hidden md:block" />
                      生活の質が大きく変わりました。」
                    </p>
                  </div>
                </div>
              </div>

              {/* Card B */}
              <div className="relative bg-amber-50 rounded-3xl border-2 border-amber-400 px-6 pb-8 pt-10">
                <div className="absolute -top-5 left-6 bg-amber-200 border-2 border-amber-400 rounded-2xl px-5 py-2 shadow">
                  <p className="text-amber-900 font-black text-lg whitespace-nowrap">Bさん(42歳・会社員)</p>
                </div>

                <div className="flex items-center gap-5 mt-2">
                  <div className="flex-shrink-0 w-24 h-24 rounded-full border-4 border-amber-300 overflow-hidden">
                    <img
                      src="https://storage.readdy-site.link/project_files/4da40bb9-7576-4498-b48d-80e36ebd8220/6a009501-e51e-42bc-9497-c6a62e5f4cf5_27190257.png?v=32628e6088723b533271e66f324ddcfd"
                      alt="アバター"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>

                  <div className="relative flex-1 bg-white rounded-2xl border-2 border-amber-300 px-5 py-4">
                    <div
                      className="absolute top-8 -left-3"
                      style={{
                        width: 0,
                        height: 0,
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: '12px solid #fcd34d',
                      }}
                    ></div>
                    <div
                      className="absolute top-8 -left-2"
                      style={{
                        width: 0,
                        height: 0,
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: '12px solid #ffffff',
                      }}
                    ></div>
                    <p className="text-base md:text-lg text-gray-800 leading-relaxed text-center">
                      「最初は半信半疑でしたが、<br className="hidden md:block" />
                      面談で詳しく説明を受けて納得。<br className="hidden md:block" />
                      現金を使わずに住宅費を削減できる仕組みに<br className="hidden md:block" />
                      驚きました。」
                    </p>
                  </div>
                </div>
              </div>

              {/* Card C */}
              <div className="relative bg-amber-50 rounded-3xl border-2 border-amber-400 px-6 pb-8 pt-10">
                <div className="absolute -top-5 left-6 bg-amber-200 border-2 border-amber-400 rounded-2xl px-5 py-2 shadow">
                  <p className="text-amber-900 font-black text-lg whitespace-nowrap">Cさん(38歳・会社員)</p>
                </div>

                <div className="flex items-center gap-5 mt-2">
                  <div className="flex-shrink-0 w-24 h-24 rounded-full border-4 border-amber-300 overflow-hidden">
                    <img
                      src="https://storage.readdy-site.link/project_files/4da40bb9-7576-4498-b48d-80e36ebd8220/6a009501-e51e-42bc-9497-c6a62e5f4cf5_27190257.png?v=32628e6088723b533271e66f324ddcfd"
                      alt="アバター"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>

                  <div className="relative flex-1 bg-white rounded-2xl border-2 border-amber-300 px-5 py-4">
                    <div
                      className="absolute top-8 -left-3"
                      style={{
                        width: 0,
                        height: 0,
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: '12px solid #fcd34d',
                      }}
                    ></div>
                    <div
                      className="absolute top-8 -left-2"
                      style={{
                        width: 0,
                        height: 0,
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: '12px solid #ffffff',
                      }}
                    ></div>
                    <p className="text-base md:text-lg text-gray-800 leading-relaxed text-center">
                      「住宅ローンの負担が重く、将来が不安でした。<br className="hidden md:block" />
                      家賃ゼロ太郎くんを利用してから、<br className="hidden md:block" />
                      貯金が毎月できるようになり、<br className="hidden md:block" />
                      家族との時間も増えました。もっと早く知りたかったです。」
                    </p>
                  </div>
                </div>
              </div>

            </div>

            <p className="text-xl md:text-3xl lg:text-5xl font-bold text-center text-gray-900 mt-12">
              <span className="text-amber-600">ぜひあなたも仲間に加わりませんか？</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}